export const MAX_SEARCH_LENGTH = 100;

export const PATIENT_SEARCH_PLACEHOLDER = 'Last name, full name or chart #';
export const ORDER_SEARCH_PLACEHOLDER = 'Chart #';

export interface PatientSearchFields {
    firstName?: string;
    lastName?: string;
    chartNumber?: string;
}

const HAS_DIGIT = /\d/;
const WHITESPACE = /\s+/;

function cleanSearch(text: string): string {
    return text.trim().slice(0, MAX_SEARCH_LENGTH).trim();
}

// "Last, First" is how the tables print names, so a comma reads as that order.
function commaName(text: string): PatientSearchFields | null {
    const comma = text.indexOf(',');
    if (comma === -1) return null;
    const lastName = text.slice(0, comma).trim();
    const firstName = text.slice(comma + 1).trim();
    return {
        lastName: lastName || undefined,
        firstName: firstName || undefined
    };
}

export function patientSearchFields(text: string): PatientSearchFields {
    const search = cleanSearch(text);
    if (!search) return {};
    if (HAS_DIGIT.test(search)) return { chartNumber: search };
    const fromComma = commaName(search);
    if (fromComma) return fromComma;
    const [first, ...rest] = search.split(WHITESPACE);
    if (rest.length === 0) return { lastName: first };
    return { firstName: first, lastName: rest.join(' ') };
}

// iTero can only filter orders by chart number, so the whole search is the chart.
export function orderSearchChart(text: string): string | undefined {
    return cleanSearch(text) || undefined;
}

export function hasSearchText(text: string): boolean {
    return cleanSearch(text) !== '';
}
